import React, { useState } from 'react';
import { NavItem } from '../types';
import { NAV_ITEMS } from '../constants';

interface DockProps {
  activeSection: string;
  onNavigate: (id: string) => void;
}

export const Dock: React.FC<DockProps> = ({ activeSection, onNavigate }) => {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <div className="fixed bottom-4 md:bottom-6 left-1/2 transform -translate-x-1/2 z-[100]">
      <div className="flex items-end gap-2 md:gap-3 px-3 md:px-4 py-3 bg-white/20 backdrop-blur-xl border border-white/20 rounded-2xl shadow-glass transition-all duration-300 hover:bg-white/30 hover:scale-105">
        {NAV_ITEMS.map((item) => {
          const isActive = activeSection === item.id;
          const isHovered = hoveredId === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
              className="group relative flex flex-col items-center justify-end transition-all duration-300 ease-out"
              style={{
                transform: isHovered ? 'translateY(-10px) scale(1.2)' : 'translateY(0) scale(1)',
                margin: '0 4px',
              }}
            >
              <div 
                className={`
                  p-3 rounded-xl shadow-lg transition-all duration-300
                  ${isActive 
                    ? 'bg-gradient-to-br from-salt-teal to-[#5aa8a7] text-white shadow-salt-teal/50' 
                    : 'bg-white/80 text-salt-charcoal hover:bg-white'}
                `}
              >
                {item.icon}
              </div>
              
              {/* Dot indicator */}
              <div className={`
                w-1 h-1 mt-1 rounded-full bg-salt-charcoal/80 transition-opacity duration-300
                ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-30'}
              `} />

              {/* Tooltip */}
              <div className={`
                absolute -top-10 left-1/2 transform -translate-x-1/2 
                px-2 py-1 bg-black/80 text-white text-[10px] rounded-md font-roboto tracking-wide whitespace-nowrap
                transition-all duration-200 pointer-events-none backdrop-blur-sm
                ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}
              `}>
                {item.label}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};